import SectionHeader from '@Web/Src/Components/SectionHeader';
import { router } from '@inertiajs/react';
import LazyImage from '@Web/Src/Components/LazyImage/index.jsx';

const BlogSection = ({ reverse = false, data }) => {
    const {
        image,
        imageLow,
        alt,
        type,
        className,
        position,
        icon,
        title,
        desc,
        imgClassName,
        link,
        linkText,
        additionalItem,
        isExternal = false,
    } = data;

    const handleRegister = () => {
        isExternal
            ? window.open(link, '_blank', 'noopener, noreferrer')
            : router.visit(route(link));
    };

    return (
        <div
            className={`${reverse ? 'flex-row-reverse' : ''} large:flex-col medium:gap-5 mt-32 flex w-full flex-row items-center justify-between gap-20`}
        >
            <SectionHeader
                type={type}
                className={className}
                position={position}
                icon={icon}
                title={title}
                desc={desc}
                link={link}
                linkText={linkText}
                handleClick={handleRegister}
                additionalItem={additionalItem}
            />
            <div className={imgClassName}>
                <LazyImage className={'w-full'} src={image} lowSrc={imageLow} alt={alt} />
            </div>
        </div>
    );
};

export default BlogSection;
